// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3erKn","load8":"Spinner_load8__fh4Z0"};